const SCAN_FLAG = {
    BOXNUMBER: 0,
    EANCODE: 1,
    QRCODE: 2
}

export default SCAN_FLAG;


// WEBPACK FOOTER //
// ./src/components/application/BoxScan/scanFlag.js